export var WhitebitBalanceType;
(function (WhitebitBalanceType) {
    WhitebitBalanceType["SPOT"] = "spot";
    WhitebitBalanceType["MAIN"] = "main";
})(WhitebitBalanceType || (WhitebitBalanceType = {}));
//# sourceMappingURL=whitebit-balance-type.enum.js.map